export default __webpack_public_path__ + "static/bed-bath-beyond-8-d-c68f78c3fb3010d5b0ce51d2ab36745d.webp";